import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { StorageClient } from '@lib-ui/client';
import { SidemenuService } from '@lib-ui/lib/services';
import { APP_ENV } from '@environments/environment.base';
import { ReleaseNotesComponent } from '@lib-ui/lib/components/release-notes';
import { downloadFile } from '@lib-ui/lib/functions/download-file';
import { UserService } from '@lib-ui/lib/services/user.service';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AccessPipe } from '@lib-ui/lib/pipes/access.pipe';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'lib-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [SidemenuService],
  imports: [
    NgIf,
    AsyncPipe,
    MatListModule,
    MatIconModule,
    RouterLink,
    AccessPipe,
    NgForOf,
    MatDialogModule,

  ],
})
export class SidemenuComponent {
  private readonly userService = inject(UserService);
  private readonly sidemenuService = inject(SidemenuService);
  private readonly environment = inject(APP_ENV);
  private readonly storageClient = inject(StorageClient);
  private readonly dialog = inject(MatDialog);
  public menu = this.sidemenuService.menu;
  public user = this.userService.state.user;

  public get version() {
    return this.environment.version;
  }

  public openReleaseNotesDialog() {
    this.dialog.open(ReleaseNotesComponent);
  }

  public openUserManual() {
    const filename = 'UserManual.pdf';
    this.storageClient.getFile(filename, 'application/pdf').subscribe({
      next: (file) => downloadFile(file.data, filename, 'application/pdf'),
    });

  }
}
